import { render, staticRenderFns } from "./toast.vue?vue&type=template&id=70523882&scoped=true&lang=html"
import script from "./toast.vue?vue&type=script&lang=js"
export * from "./toast.vue?vue&type=script&lang=js"
import style0 from "./toast.vue?vue&type=style&index=0&id=70523882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70523882",
  null
  
)

export default component.exports